import React from 'react';
import { Form, Select } from 'antd';
import { selectInputFilterHelper } from '@common/services';

type TechnologyType = {
  id: string;
  name: string;
};

export function TechnologiesSelect({
  technologies,
  hidden = false,
}: {
  technologies: TechnologyType[];
  hidden?: boolean;
}) {
  return (
    <Form.Item
      label="Technologies"
      name="technologyIds"
      colon={false}
      hidden={hidden}
    >
      <Select
        allowClear
        size="large"
        mode="multiple"
        filterOption={selectInputFilterHelper}
        placeholder="Select technologies..."
        getPopupContainer={(trigger) => trigger.parentNode}
      >
        {technologies.map((tech) => (
          <Select.Option value={tech.id} key={tech.id}>
            {tech.name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
}
